import { DriverStatus } from '../domain/driver/DriverStatus';

const DRIVER_STATUS = {
  notStarted: `not_started`,
  inTransit: `in_transit`,
  finished: `finished`,
} as Record<string, DriverStatus>;

export default DRIVER_STATUS;
